// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_pz-0";